import { ApiServerItemIterator } from '@leverege/molten/data-viewers';
import { GroupDelegate, Relationship } from '@leverege/molten/imagine';
import { DataSources } from '@leverege/ui-attributes';
import { GlobalState } from '@leverege/ui-redux';
export default class ApiServerBillingItemIterator extends ApiServerItemIterator {
  constructor(opts) {
    super(opts);
    this.perPage = 100;
  }
  async populateParentRelationships(items, fields) {
    const res = super.populateParentRelationships(items, fields);
    await Promise.all([this.getPaymentAggregations(items), this.getAddendumCreditAggregations(items), this.getAddendumChargeAggregations(items)]);
    return res;
  }
  async getPaymentAggregations(items) {
    const rel = Relationship.getByPath('payment');
    const actions = DataSources.getDelegate(items[0]);
    const match = actions.match;
    const paymentDelegate = new GroupDelegate({
      relationship: rel.createResolved(match),
      match,
      objectType: rel.options.objectType,
      queryName: 'totalPaymentsAgg'
    });
    return GlobalState.dispatch(paymentDelegate.search({
      limit: 0,
      filter: {
        type: 'equals',
        field: 'data/bill/id',
        value: items.map(item => item.id)
      },
      aggs: {
        byBill: {
          type: 'terms',
          field: 'data/bill/id',
          size: items.length,
          aggs: {
            payments: {
              type: 'stats',
              field: 'data/amount'
            }
          }
        }
      }
    }, {
      ttl: 30000
    }));
  }
  getAddendumChargeAggregations(items) {
    const rel = Relationship.getByPath('addendum');
    const actions = DataSources.getDelegate(items[0]);
    const match = actions.match;
    const addendumDelegate = new GroupDelegate({
      relationship: rel.createResolved(match),
      match,
      objectType: rel.options.objectType,
      queryName: 'totalAddendumChargesAgg'
    });
    return GlobalState.dispatch(addendumDelegate.search({
      limit: 0,
      filter: {
        type: 'logical',
        operator: 'and',
        conditions: [{
          type: 'equals',
          field: 'data/bill/id',
          value: items.map(item => item.id)
        }, {
          field: 'data/type',
          type: 'equals',
          value: 'charge'
        }]
      },
      aggs: {
        byBill: {
          type: 'terms',
          field: 'data/bill/id',
          size: items.length,
          aggs: {
            charges: {
              type: 'stats',
              field: 'data/amount'
            }
          }
        }
      }
    }, {
      ttl: 30000
    }));
  }
  getAddendumCreditAggregations(items) {
    const rel = Relationship.getByPath('addendum');
    const actions = DataSources.getDelegate(items[0]);
    const match = actions.match;
    const addendumDelegate = new GroupDelegate({
      relationship: rel.createResolved(match),
      match,
      objectType: rel.options.objectType,
      queryName: 'totalAddendumCreditsAgg'
    });
    return GlobalState.dispatch(addendumDelegate.search({
      limit: 0,
      filter: {
        type: 'logical',
        operator: 'and',
        conditions: [{
          type: 'equals',
          field: 'data/bill/id',
          value: items.map(item => item.id)
        }, {
          field: 'data/type',
          type: 'equals',
          value: 'credit'
        }]
      },
      aggs: {
        byBill: {
          type: 'terms',
          field: 'data/bill/id',
          size: items.length,
          aggs: {
            credits: {
              type: 'stats',
              field: 'data/amount'
            }
          }
        }
      }
    }, {
      ttl: 30000
    }));
  }
}